// * MUI Components
import { Box, Typography, styled } from "@mui/material";
import { AccountBalance, Rule, AutoAwesome } from "@mui/icons-material";
import ShapeBackground from "./fancy/ShapeBackground";

// * MUI Styled Components
const CustomBox = styled(Box)(({ theme }) => ({
  width: "40%",
  [theme.breakpoints.down("md")]: {
    width: "85%",
  },
}));

const GuidesBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-around",
  width: "70%",
  marginTop: theme.spacing(5),
  marginBottom: theme.spacing(5),
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
  [theme.breakpoints.down("sm")]: {
    marginBottom: "0",
    flexDirection: "column",
  },
}));

const GuideBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginTop: theme.spacing(5),
  [theme.breakpoints.down("sm")]: {
    margin: theme.spacing(2, 0, 2, 0),
  },
}));

export default function Guide() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 8,
        padding: 4,
        position: "relative",
        overflow: "hidden",
      }}
    >
      <ShapeBackground />
      <div
        style={{
          width: "5%",
          height: "5px",
          backgroundColor: "#3370FF",
          margin: "0 auto",
          position: "relative",
          zIndex: 1,
        }}
      ></div>

      <Typography
        variant="h3"
        sx={{ fontSize: "35px", fontWeight: "bold", color: "#2B3674", my: 3, position: "relative", zIndex: 1 }}
      >
        How It Works
      </Typography>

      <CustomBox sx={{ position: "relative", zIndex: 1 }}>
        <Typography
          variant="body2"
          sx={{
            fontSize: "16px",
            fontWeight: "500",
            color: "#4A5568",
            textAlign: "center",
          }}
        >
          Get started with Dizpurse in three simple steps
        </Typography>
      </CustomBox>

      <GuidesBox sx={{ position: "relative", zIndex: 1 }}>
        <GuideBox>
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              backgroundColor: "#E6F0FF",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 2,
            }}
          >
            <AccountBalance sx={{ fontSize: 40, color: "#3370FF" }} />
          </Box>
          <Typography
            variant="h6"
            sx={{
              fontWeight: "600",
              fontSize: "20px",
              color: "#2B3674",
              my: 1,
              textAlign: "center",
            }}
          >
            1. Connect your accounts securely
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontSize: "14px",
              color: "#4A5568",
              textAlign: "center",
              px: 2,
            }}
          >
            Use Plaid's secure Link flow to safely connect your bank accounts
          </Typography>
        </GuideBox>

        <GuideBox>
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              backgroundColor: "#FFE9E3",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 2,
            }}
          >
            <Rule sx={{ fontSize: 40, color: "#FF6B3D" }} />
          </Box>
          <Typography
            variant="h6"
            sx={{
              fontWeight: "600",
              fontSize: "20px",
              color: "#2B3674",
              my: 1,
              textAlign: "center",
            }}
          >
            2. Create rules
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontSize: "14px",
              color: "#4A5568",
              textAlign: "center",
              px: 2,
            }}
          >
            When you spend in a category → move money. When balance is low → transfer from savings. When you overspend → trigger a penalty bucket
          </Typography>
        </GuideBox>

        <GuideBox>
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              backgroundColor: "#F0E9FF",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 2,
            }}
          >
            <AutoAwesome sx={{ fontSize: 40, color: "#4318FF" }} />
          </Box>
          <Typography
            variant="h6"
            sx={{
              fontWeight: "600",
              fontSize: "20px",
              color: "#2B3674",
              my: 1,
              textAlign: "center",
            }}
          >
            3. Let Dizpurse run in the background
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontSize: "14px",
              color: "#4A5568",
              textAlign: "center",
              px: 2,
            }}
          >
            Your automations keep your finances healthy while you focus on living your life
          </Typography>
        </GuideBox>
      </GuidesBox>
    </Box>
  );
}
